/** Orden cronológico ascendente: más viejo primero. */
export function sortMovimientosCronologico(a, b) {
  const fa = new Date(a.fecha).getTime();
  const fb = new Date(b.fecha).getTime();
  if (fa !== fb) return fa - fb;
  const ca = a.created_at ? new Date(a.created_at).getTime() : 0;
  const cb = b.created_at ? new Date(b.created_at).getTime() : 0;
  if (ca !== cb) return ca - cb;
  return (a.id || 0) - (b.id || 0);
}

export function sortFondosCronologico(a, b) {
  const fa = new Date(a.fecha).getTime();
  const fb = new Date(b.fecha).getTime();
  if (fa !== fb) return fa - fb;
  return (a.id || 0) - (b.id || 0);
}

function movimientoExcluidoDeSaldo(m) {
  if (m.excluir_saldo === 1 || m.excluir_saldo === true) return true;
  const concepto = String(m.concepto || '').toLowerCase();
  return concepto.includes('pre-sistema') || concepto.includes('pre sistema');
}

export function deltaSaldoMovimiento(m) {
  if (movimientoExcluidoDeSaldo(m)) return 0;
  return m.tipo_movimiento === 'DEBITO'
    ? parseFloat(m.monto) || 0
    : -(parseFloat(m.monto) || 0);
}

export function deltaSaldoFondo(m) {
  const monto = parseFloat(m.monto_total) || 0;
  if (m.debito != null || m.credito != null) {
    return (parseFloat(m.credito) || 0) - (parseFloat(m.debito) || 0);
  }
  return m.tipo === 'ingreso' ? monto : -monto;
}
